import { baseImageUrl, platform } from '../constants'

const capitalize = (str: string) =>
  str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()

export const getStepFourMobileImagePath = (
  browser: string,
  os: string,
): string => {
  const imagePaths: { [key: string]: string } = {
    'mobile-Android-Edge': `${baseImageUrl}/browsers_step_four_mobile/mobile-android-edge.png`,
    'mobile-Android-Samsung': `${baseImageUrl}/browsers_step_four_mobile/mobile-android-samsung.png`,
  }

  const key = `${platform}-${capitalize(os)}-${capitalize(browser)}`

  return (
    imagePaths[key] ||
    'No se encontro la imagen para este dispositivo o browser'
  )
}
